import { firebase } from "../firebase";
import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { nanoid } from "nanoid";

const db = collection(firebase, "/chatMessageFlag");

class ChatMessageFlagDataService {
  async getAll() {
    const snapshot = await getDocs(db);
    return snapshot.docs.map((doc) => ({ id: doc.id, content: doc.data() }));
  }

  async get(id) {
    const snapshot = await getDoc(doc(firebase, "/chatMessageFlag", id));
    return snapshot;
  }

  async getFromChat(id) {
    const q = await getDocs(
      query(collection(firebase, "/chatMessageFlag"), where("chat", "==", id))
    );

    return q.docs.map((doc) => ({ id: doc.id, message: doc.data() }));
  }
  async create(id, data) {
    const docRef = await setDoc(doc(firebase, "chatMessageFlag", id), data);
    return docRef;
  }

  async update(id, data) {
    await updateDoc(doc(firebase, "/chatMessageFlag", id), data);
  }

  async delete(id) {
    return await deleteDoc(doc(firebase, "/chatMessageFlag", id));
  }

  deleteAll() {
    return;
  }

  findByTitle(title) {
    return;
  }
}

export default new ChatMessageFlagDataService();
